export const imageTypes: string[] = ['image/png', 'image/jpg', 'image/jpeg'];
